// extracted by mini-css-extract-plugin
module.exports = {"header":"Collapse_header__1_MCS","controls":"Collapse_controls__2yEk7","expand":"Collapse_expand__30LD1"};